<template>
    <div class="PracticeFeed" @click="isUserAllowedToStartScenario && goToActiveScenario()">
        <div class="image-and-informations">
            <div class="image-wrapper">
                <svgicon icon="practice_icon" :original="true" class="icon" />
                <div class="number">
                    {{ currentScenarioInfo ? currentScenarioInfo.habitJourneyIndex + 1 : activeJourney.index + 1 }}
                </div>
            </div>
            <div class="informations-wrapper">
                <p>
                    {{ currentScenario.subtitle }}
                </p>
                <h3>
                    {{ currentScenario.title }}
                </h3>
                <p class="text">
                    {{ currentScenario.text }}
                </p>
            </div>
        </div>
        <div class="button-wrapper">
            <a class="button-blue">{{ isUserAllowedToStartScenario ? 'Start' : $t('locked') }}</a>
        </div>
    </div>
</template>

<translations>
    locked: 'Locked'
    locked_no: 'Låst'
</translations>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        activeJourney: {
            type: Object,
            required: true,
            default: () => {}
        },
        currentScenario: {
            type: Object,
            required: false,
            default: () => {}
        },
        lifeskillId: {
            type: String,
            required: false,
            default: ''
        },
        currentScenarioInfo: {
            type: Object,
            required: false,
            default: () => {}
        },
        courseId: {
            type: String,
            required: false,
            default: ''
        },
        didUserScenarioToday: {
            type: Boolean,
            required: true
        }
    },

    computed: {
        ...mapGetters({
            getStepById: 'moduleCourse/getStepById',
            getJourneyById: 'moduleCourse/getJourneyById',
            getScenarioById: 'moduleCourse/getScenarioById'
        }),

        hasActiveScenario() {
            return this.currentScenario && !this.currentScenario.locked;
        },

        isUserAllowedToStartScenario() {
            return this.hasActiveScenario && !this.didUserScenarioToday;
        }
    },

    methods: {
        goToFirstActivity() {
            this.isTheoryFeed ? this.goToTheory() : this.goToActiveScenario();
        },

        goToActiveScenario() {
            this.$router.push({
                name: 'DashboardScenarioView',
                params: {
                    lifeskillId: this.lifeskillId,
                    stepId: this.currentScenarioInfo.stepId,
                    scenarioIndex: this.currentScenarioInfo.scenarioIndex
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.PracticeFeed {
    display: flex;
    background: #fdfdfd;
    box-shadow: 0px 2px 23px 3px rgba(79, 79, 79, 0.1);
    border-radius: 4px;
    padding: 1.2em 18.5px;
    width: 100%;
    position: relative;
    justify-content: space-between;
    margin: 1em 0;
    cursor: pointer;

    @media (max-width: 530px) {
        padding: 1.2em 8px;
    }
}
.image-and-informations {
    display: flex;
    align-items: center;
}
.image-wrapper {
    min-width: 97px;
    min-height: 97px;
    max-width: 97px;
    max-height: 97px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    @media (max-width: 530px) {
        min-width: 68px;
        min-height: 68px;
        max-width: 68px;
        max-height: 68px;
    }

    .icon {
        width: 100%;
        height: 100%;
    }
    .number {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-size: 12px;
        color: white;
        @media (max-width: 530px) {
            font-size: 10px;
        }
    }
}
.informations-wrapper {
    padding: 0 20px;
    @media (max-width: 530px) {
        padding: 0 10px;
    }

    p {
        margin: 0;
        margin-top: 5px;
        color: #727272;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        @media (max-width: 530px) {
            font-size: 14px;
        }
    }
    h3 {
        font-size: 22px;
        font-weight: 600;
        line-height: 26px;
        margin: 0;
        color: #151515;
        max-width: 600px;
        padding-right: 2em;
        @media (max-width: 530px) {
            font-size: 16px;
            padding-right: 0.5em;
        }
    }
    .text {
        margin-top: 0.8em;
        @media (max-width: 530px) {
            margin-top: 0.25em;
        }
    }
}
.button-wrapper {
    display: flex;
    align-items: center;
}
</style>
